// SOVRANOVA — disguise/survivor-safe mode signal (Task 5, Sprint 2)
// ---------------------------------------------------------------------------
// Sprint-2 Task 5 brief: hide the Settings "Notifications" toggle entirely
// whenever survivor-safe/disguise mode is active. Before adding this, we
// grepped the whole codebase (backend AND frontend) for
// survivor_safe|survivorsafe|disguise|stealth — nothing exists anywhere.
// frontend/src/components/engine/QuickExitButton.jsx independently confirms
// this: its own header notes "v1 has no prior disguise/quick-exit mechanic"
// before that file was added. The only related thing in this app, Guided
// Paths' Quick Exit, is a transient, component-local render-phase swap (see
// QuickExitButton.jsx's QuickExitNeutralScreen) — it is not a persistent or
// global "mode", is never written to storage, and is not queryable from here
// or anywhere outside that one view.
//
// So there is currently nothing to gate on. Per the brief's fallback
// ("if no queryable flag exists client-side, hide toggle whenever disguise
// mode active"), this reads a conventionally-named localStorage flag —
// `sovranova_disguise_mode` — following the exact same direct-localStorage
// convention RegionPicker.jsx already uses for `sovranova_region` (a plain
// key, never part of the settings_v1 blob, never inferred automatically).
// Nothing in this codebase writes this key today, so isDisguiseModeActive()
// always returns false right now and the Notifications toggle is visible to
// everyone. This is deliberate forward-compatibility: if/when a real
// disguise-mode feature ships and starts setting this key, the Notifications
// toggle disappears automatically, with zero further Settings changes
// required. See .superpowers/sdd/s2-task-5-report.md for the full writeup.
const DISGUISE_MODE_KEY = 'sovranova_disguise_mode'

export function isDisguiseModeActive() {
  try {
    return localStorage.getItem(DISGUISE_MODE_KEY) === 'true'
  } catch {
    return false
  }
}
